export default __webpack_public_path__ + "938533a9f9076ea5f78283350c1414d7.png";